export const educationData = [
    {
        id: 1,
        institution: 'Odisha govt press colony high school',
        course: 'Board of Seconday Education',
        startYear: '2003',
        endYear: '2013'
    },
    {
        id: 2,
        institution: 'Saraswati jr. science college',
        course: 'Council of Higher Secondary Education',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 3,
        institution: 'Shailabala womens autonomous college',
        course: 'Bachelor of science in CSE',
        startYear: '2015',
        endYear: '2018'
    },
]